// extracted by mini-css-extract-plugin
export default {"mapContainer":"responsive-map_mapContainer__h1yiG","resetBtn":"responsive-map_resetBtn__avuTM"};